import React from 'react'

export default function GalpinLogo(props) {
  return (
    <svg style={{height: '100%', verticalAlign: 'top', width: 'auto',}} height="37" viewBox="0 0 140 37" fill="none" {...props}>
      <defs>
        <linearGradient id="fordBlueGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#003478" />
          <stop offset="100%" stopColor="#0066CC" />
        </linearGradient>
      </defs>
      <g>
        {/* Background oval shape */}
        <ellipse cx="70" cy="18.5" rx="68" ry="16" fill="url(#fordBlueGradient)" stroke="#002a5c" strokeWidth="1"/>

        {/* GALPIN text - main brand */}
        <text
          x="70"
          y="15"
          fontSize="14"
          fontWeight="bold"
          fontFamily="Arial, sans-serif"
          fill="white"
          textAnchor="middle"
          letterSpacing="1px"
        >
          GALPIN
        </text>

        {/* Ford dealership subtitle */}
        <text
          x="70"
          y="26"
          fontSize="7"
          fontFamily="Arial, sans-serif"
          fill="#E8F4FD"
          textAnchor="middle"
          letterSpacing="0.5px"
        >
          FORD DEALERSHIP
        </text>

        {/* Decorative elements - left side */}
        <polygon points="8,18.5 16,14 16,23" fill="white" opacity="0.8"/>

        {/* Decorative elements - right side */}
        <polygon points="132,18.5 124,14 124,23" fill="white" opacity="0.8"/>

        {/* Small Ford oval badge */}
        <ellipse cx="25" cy="18.5" rx="8" ry="6" fill="white" opacity="0.9"/>
        <text
          x="25"
          y="20"
          fontSize="5"
          fontWeight="bold"
          fontFamily="Arial, sans-serif"
          fill="#003478"
          textAnchor="middle"
        >
          F
        </text>
      </g>
    </svg>
  )
}
